import script from "./ModalContentMixin.vue?vue&type=script&lang=ts"
export * from "./ModalContentMixin.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__